import { useState } from "react";
import { CLIENT_COLORS, CYCLE } from "../constants";
import { curMonth } from "../utils";
import { Avatar, Btn, ProgressBar, Stage, StageTabs, KpiStrip, BlockHead, ExpandTable, Selo } from "../components/primitives";

export function ClientsView({ clients, tasks, onGoClient, onNewClient }) {
  const [filter, setFilter] = useState("Todos");
  const types = ["Todos", ...new Set(clients.map((c) => c.type))];
  const month = curMonth();

  const visible = clients.filter((c) => filter === "Todos" || c.type === filter);
  const porStatus = (s) => clients.filter((c) => c.status === s).length;
  const tom = { Ativo: "ok", Pausado: "warn", Encerrado: "off" };

  return (
    <div className="view">
      <Stage
        path="clientes"
        title="Carteira de"
        hl="clientes"
        lead={`${clients.length} cadastrados`}
        actions={<Btn onClick={onNewClient} variant="primary">+ Novo cliente</Btn>}
        tabs={<StageTabs label="Filtrar por tipo" items={types.map((t) => ({ id: t, label: t }))} active={filter} onChange={setFilter} />}
      />

      <KpiStrip items={[
        { label: "Ativos", value: porStatus("Ativo"), tone: "ok", sub: "em operação" },
        { label: "Pausados", value: porStatus("Pausado"), tone: porStatus("Pausado") ? "warn" : "", sub: "sem campanha" },
        { label: "Encerrados", value: porStatus("Encerrado"), sub: "histórico" },
        { label: "Neste filtro", value: visible.length, sub: filter },
      ]} />

      <BlockHead title="Clientes" sub="Clique na linha para ver o resumo; o botão abre a ficha completa." />
      <ExpandTable
        minWidth={620}
        rows={visible}
        empty="Nenhum cliente neste filtro"
        columns={[
          { key: "name", label: "Cliente", render: (c) => {
            const col = CLIENT_COLORS[c.type] || CLIENT_COLORS["Interno"];
            return (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                <Avatar name={c.name} size={30} bg={col.bg} color={col.tx} />
                <span style={{ display: "grid" }}>
                  <span className="name">{c.name}</span>
                  <span className="sub">{c.type}{c.grupo ? ` · ${c.grupo}` : ""}</span>
                </span>
              </span>
            );
          } },
          { key: "stage", label: "Etapa", render: (c) => (CYCLE.find((s) => s.id === c.cycle_stage) || CYCLE[5]).l },
          { key: "tasks", label: "Tarefas do mês", render: (c) => {
            const cTasks = tasks.filter((t) => t.client_id === c.id && !t.archived && t.month === month);
            const done = cTasks.filter((t) => t.status === "Concluído").length;
            return cTasks.length ? <div style={{ minWidth: 120 }}><ProgressBar done={done} total={cTasks.length} /></div> : <span className="sub">—</span>;
          } },
          { key: "status", label: "Situação", render: (c) => <Selo tone={tom[c.status] || "off"}>{c.status}</Selo> },
        ]}
        detail={(c) => (
          <div style={{ display: "grid", gap: 12, paddingTop: 6 }}>
            <dl className="facts">
              {c.specialty && <><dt>Nicho</dt><dd>{c.specialty}</dd></>}
              {c.notes && <><dt>Plataformas</dt><dd>{c.notes}</dd></>}
              {c.dia_relatorio && <><dt>Relatório</dt><dd>dia {c.dia_relatorio}</dd></>}
              {c.cidades && <><dt>Cidades</dt><dd>{c.cidades}</dd></>}
            </dl>
            <div><Btn sm variant="primary" onClick={() => onGoClient(c.id)}>Abrir ficha</Btn></div>
          </div>
        )}
      />
    </div>
  );
}
